import { createSlice } from '@reduxjs/toolkit';
import { getProductDetailsSortedImagesByVariant } from '@/utils/array';
import { getActiveVariantDetail } from '../thunk/products-thunk';

const productDetailSlice = createSlice({
  name: 'product-detail',
  initialState: {
    currentParentProductDetail: null,
    currentProductDetail: null,
    detail: null,
    tags: [],
    specifications: [],
    warranties: [],
    faqs: [],
    allAttributes: [],
    allVariants: [],
    selectedVariantAttributesDetail: null,
    urlSlugChangeTracker: true,
    urlInitialSlug: '',
    categoryInfo: null,
    installationDetail: null,
    elements: [],
    sibling_elements: [],
  },
  reducers: {
    setSelectedVariantAttributesDetail: (state, action) => {
      state.selectedVariantAttributesDetail = action.payload;
    },
    setInitialCurrentProductDetail: (state, action) => {
      const { parentsInfo, initialVariant } = action.payload;

      const activeVariant = getActiveVariantDetail({
        productDetail: parentsInfo,
        initialVariant,
      });

      state.categoryInfo =
        parentsInfo?.parent_category ?? parentsInfo?.category;
      state.currentParentProductDetail = parentsInfo;
      state.detail = parentsInfo?.product?.details ?? null;
      state.tags = parentsInfo?.tags ?? [];
      state.specifications = parentsInfo?.specifications ?? [];
      state.warranties = parentsInfo?.warranties ?? [];
      state.faqs = parentsInfo.faqs ?? [];
      state.allAttributes = parentsInfo?.attribute ?? [];
      state.allVariants = parentsInfo?.variants ?? [];
      state.installationDetail = parentsInfo?.installation_fee ?? null;

      state.currentProductDetail = activeVariant;

      // Update variant info from array to object
      const attributeInfo = activeVariant?.attribute?.reduce(
        (acc, attr) => ({
          ...acc,
          [attr.name.en]: attr.attribute_value[0],
        }),
        {},
      );

      state.selectedVariantAttributesDetail = { ...attributeInfo };
    },
    updateCurrentProductDetail: (state, action) => {
      state.currentProductDetail = action.payload;
    },

    updateVariantInfo: (state, action) => {
      state.urlSlugChangeTracker = false;
      const { label, value, nextSlug } = action.payload;
      // payload => attr, value
      const updatedVariantAttribute = {
        ...state.selectedVariantAttributesDetail,
        [label]: value,
      };

      state.selectedVariantAttributesDetail = updatedVariantAttribute;

      // Find and set matching variant
      const matchingVariant = state.allVariants.find(
        (variant) => variant.slug === nextSlug,
      );

      if (matchingVariant) {
        state.currentProductDetail = {
          ...matchingVariant,
          parentSlug: state.currentParentProductDetail?.product?.slug,
          parentName: state.currentParentProductDetail?.product?.name,
          image_1x1:
            state.currentParentProductDetail?.product?.image_1x1 ?? null,
          details_page_image:
            getProductDetailsSortedImagesByVariant(
              state.currentParentProductDetail?.product?.images?.tall,
              matchingVariant.slug,
            ) ?? [],
          image: state.currentParentProductDetail?.product?.image,
          ribbon: state.currentParentProductDetail?.product?.ribbon,
          brand: state.currentParentProductDetail.product.brand,
        };
      }
    },
    updateInitialUrlVariant: (state, action) => {
      state.urlSlugChangeTracker = false;
      state.urlInitialSlug = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const {
  updateCurrentProductDetail,
  setSelectedVariantAttributesDetail,
  setInitialCurrentProductDetail,
  updateVariantInfo,
  updateInitialUrlVariant,
} = productDetailSlice.actions;

export default productDetailSlice.reducer;
